// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__u4pqI","pagination":"Category_pagination__1cURD","wrapper":"Category_wrapper__14fnD","header":"Category_header__21EP7","content":"Category_content__2WV6Y"};